import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  GetSuperAdminSMSStatsAPI,
  SendSMSLinkApi,
  SuperAdminSMSStatsAPIResponse,
} from '@sc/data-access-models';

@Injectable({
  providedIn: 'root',
})
export class SmsHttpService {
  private readonly dossierCustomerUrl = '/api/dossier/auth/customer';
  private readonly superAdminSmsStatsUrl = '/api/partners/stats/sms';

  constructor(private readonly httpClient: HttpClient) {}

  sendLinkToCustomer(smsParams: SendSMSLinkApi) {
    return this.httpClient.post(this.dossierCustomerUrl, smsParams, {
      headers: { requestName: 'sms-http sendLinkToCustomer' },
    });
  }

  getSuperAdminSmsStats(smsParams: GetSuperAdminSMSStatsAPI) {
    return this.httpClient.post<SuperAdminSMSStatsAPIResponse>(
      this.superAdminSmsStatsUrl,
      smsParams,
      {
        headers: { requestName: 'sms-http getSuperAdminSmsStats' },
      }
    );
  }
}
